import { Repository } from "./adapters/repository";

import * as retrievePlanzoneResources from "./useCases/retrievePlanzoneResources";
import * as retrieveZoneResources from "./useCases/retrieveZoneResources";
import * as retrieveResource from "./useCases/retrieveResource";
import * as retrieveProjectResources from "./useCases/retrieveProjectResources";
import * as addPlanzoneMaterialResource from "./useCases/addPlanzoneMaterialResource";
import * as addProjectMaterialResource from "./useCases/addProjectMaterialResource";
import * as addPlanzoneVirtualResource from "./useCases/addPlanzoneVirtualResource";
import * as addProjectVirtualResource from "./useCases/addProjectVirtualResource";
import * as addPlanzoneResourceToProject from "./useCases/addPlanzoneResourceToProject";
import * as addPlanzoneResourcesToProject from "./useCases/addPlanzoneResourcesToProject";
import * as addEveryoneToProject from "./useCases/addEveryoneToProject";
import * as removeResourceFromProject from "./useCases/removeResourceFromProject";
import * as removeResourceFromPlanzone from "./useCases/removeResourceFromPlanzone";
import * as editResource from "./useCases/editResource";
import * as editProjectResource from "./useCases/editProjectResource";
import * as editResourceWeeklyCalendar from "./useCases/editResourceWeeklyCalendar";
import * as retrieveResourceProjects from "./useCases/retrieveResourceProjects";
import * as assignManagerToResource from "./useCases/assignManagerToResource";
import * as unAssignManagerFromResource from "./useCases/unAssignManagerFromResource";
import * as assignEveryoneToManager from "./useCases/assignEveryoneToManager";
import * as removeSubordinates from "./useCases/removeSubordinates";
import * as retrieveResourceSubordinates from "./useCases/retrieveResourceSubordinates";
import * as retrievePlanzoneResourcesListing from "./useCases/retrievePlanzoneResourcesListing";
import * as retrievePlanzoneResourcesCounts from "./useCases/retrievePlanzoneResourcesCounts";
import * as retrieveProjectResourcesListing from "./useCases/retrieveProjectResourcesListing";
import * as retrieveFilterResources from "./useCases/retrieveFilterResources";
import * as retrieveResourcesByUuids from "./useCases/retrieveResourcesByUuids";
import * as assignCalendarHolidaysToResource from "./useCases/assignCalendarHolidaysToResource";
import * as retrieveResourceCalendarHolidays from "./useCases/retrieveResourceCalendarHolidays";
import * as disableProjectResource from "./useCases/disableProjectResource";
import * as activateProjectResource from "./useCases/activateProjectResource";
import * as disableResource from "./useCases/disableResource";
import * as activateResource from "./useCases/activateResource";
import * as unAssignCalendarHolidaysFromResource from "./useCases/unAssignCalendarHolidaysFromResource";
import * as addPlanzoneResourceToProjects from "./useCases/addPlanzoneResourceToProjects";
import * as changeProfilePicture from "./useCases/changeProfilePicture";
import * as retrieveProjectResourceAssignments from "./useCases/retrieveProjectResourceAllocations";
import * as transferProjectResourceAllocations from "./useCases/transferProjectResourceAllocations";

enum UseCases {
  retrieveResource = "retrieveResource",
  retrieveProjectResources = "retrieveProjectResources",
  addPlanzoneMaterialResource = "addPlanzoneMaterialResource",
  addPlanzoneVirtualResource = "addPlanzoneVirtualResource",
  retrievePlanzoneResources = "retrievePlanzoneResources",
  retrieveZoneResources = "retrieveZoneResources",
  addProjectMaterialResource = "addProjectMaterialResource",
  addProjectVirtualResource = "addProjectVirtualResource",
  addPlanzoneResourceToProject = "addPlanzoneResourceToProject",
  addPlanzoneResourcesToProject = "addPlanzoneResourcesToProject",
  addEveryoneToProject = "addEveryoneToProject",
  removeResourceFromPlanzone = "removeResourceFromPlanzone",
  editResource = "editResource",
  removeResourceFromProject = "removeResourceFromProject",
  editProjectResource = "editProjectResource",
  editResourceWeeklyCalendar = "editResourceWeeklyCalendar",
  retrieveResourceProjects = "retrieveResourceProjects",
  assignManagerToResource = "assignManagerToResource",
  unAssignManagerFromResource = "unAssignManagerFromResource",
  assignEveryoneToManager = "assignEveryoneToManager",
  removeSubordinates = "removeSubordinates",
  retrieveResourceSubordinates = "retrieveResourceSubordinates",
  retrievePlanzoneResourcesListing = "retrievePlanzoneResourcesListing",
  retrieveProjectResourcesListing = "retrieveProjectResourcesListing",
  retrieveFilterResources = "retrieveFilterResources",
  retrieveResourcesByUuids = "retrieveResourcesByUuids",
  retrievePlanzoneResourcesCounts = "retrievePlanzoneResourcesCounts",
  assignCalendarHolidaysToResource = "assignCalendarHolidaysToResource",
  retrieveResourceCalendarHolidays = "retrieveResourceCalendarHolidays",
  disableProjectResource = "disableProjectResource",
  activateProjectResource = "activateProjectResource",
  disableResource = "disableResource",
  activateResource = "activateResource",
  unAssignCalendarHolidaysFromResource = "unAssignCalendarHolidaysFromResource",
  addPlanzoneResourceToProjects = "addPlanzoneResourceToProjects",
  changeProfilePicture = "changeProfilePicture",
  retrieveProjectResourceAllocations = "retrieveProjectResourceAllocations",
  transferProjectResourceAllocations = "transferProjectResourceAllocations",
}

interface Core {
  [UseCases.editResource]: editResource.Interactor;
  [UseCases.retrieveResource]: retrieveResource.Interactor;
  [UseCases.retrieveProjectResources]: retrieveProjectResources.Interactor;
  [UseCases.addPlanzoneMaterialResource]: addPlanzoneMaterialResource.Interactor;
  [UseCases.addProjectMaterialResource]: addProjectMaterialResource.Interactor;
  [UseCases.addPlanzoneVirtualResource]: addPlanzoneVirtualResource.Interactor;
  [UseCases.retrievePlanzoneResources]: retrievePlanzoneResources.Interactor;
  [UseCases.retrieveZoneResources]: retrieveZoneResources.Interactor;
  [UseCases.addProjectVirtualResource]: addProjectVirtualResource.Interactor;
  [UseCases.addPlanzoneResourceToProject]: addPlanzoneResourceToProject.Interactor;
  [UseCases.addPlanzoneResourcesToProject]: addPlanzoneResourcesToProject.Interactor;
  [UseCases.addEveryoneToProject]: addEveryoneToProject.Interactor;
  [UseCases.removeResourceFromProject]: removeResourceFromProject.Interactor;
  [UseCases.removeResourceFromPlanzone]: removeResourceFromPlanzone.Interactor;
  [UseCases.editProjectResource]: editProjectResource.Interactor;
  [UseCases.editResourceWeeklyCalendar]: editResourceWeeklyCalendar.Interactor;
  [UseCases.retrieveResourceProjects]: retrieveResourceProjects.Interactor;
  [UseCases.assignManagerToResource]: assignManagerToResource.Interactor;
  [UseCases.unAssignManagerFromResource]: unAssignManagerFromResource.Interactor;
  [UseCases.assignEveryoneToManager]: assignEveryoneToManager.Interactor;
  [UseCases.removeSubordinates]: removeSubordinates.Interactor;
  [UseCases.retrieveResourceSubordinates]: retrieveResourceSubordinates.Interactor;
  [UseCases.retrievePlanzoneResourcesListing]: retrievePlanzoneResourcesListing.Interactor;
  [UseCases.retrieveProjectResourcesListing]: retrieveProjectResourcesListing.Interactor;
  [UseCases.retrieveFilterResources]: retrieveFilterResources.Interactor;
  [UseCases.retrieveResourcesByUuids]: retrieveResourcesByUuids.Interactor;
  [UseCases.retrievePlanzoneResourcesCounts]: retrievePlanzoneResourcesCounts.Interactor;
  [UseCases.assignCalendarHolidaysToResource]: assignCalendarHolidaysToResource.Interactor;
  [UseCases.retrieveResourceCalendarHolidays]: retrieveResourceCalendarHolidays.Interactor;
  [UseCases.disableProjectResource]: disableProjectResource.Interactor;
  [UseCases.activateProjectResource]: activateProjectResource.Interactor;
  [UseCases.disableResource]: disableResource.Interactor;
  [UseCases.activateResource]: activateResource.Interactor;
  [UseCases.unAssignCalendarHolidaysFromResource]: unAssignCalendarHolidaysFromResource.Interactor;
  [UseCases.addPlanzoneResourceToProjects]: addPlanzoneResourceToProjects.Interactor;
  [UseCases.changeProfilePicture]: changeProfilePicture.Interactor;
  [UseCases.retrieveProjectResourceAllocations]: retrieveProjectResourceAssignments.Interactor;
  [UseCases.transferProjectResourceAllocations]: transferProjectResourceAllocations.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore({ repository }: Dependencies): Core {
  return {
    [UseCases.retrievePlanzoneResources]:
      retrievePlanzoneResources.createInteractor(repository),
    [UseCases.retrieveZoneResources]:
      retrieveZoneResources.createInteractor(repository),
    [UseCases.retrieveResource]: retrieveResource.createInteractor(repository),
    [UseCases.retrieveProjectResources]:
      retrieveProjectResources.createInteractor(repository),
    [UseCases.addPlanzoneMaterialResource]:
      addPlanzoneMaterialResource.createInteractor(repository),
    [UseCases.addProjectMaterialResource]:
      addProjectMaterialResource.createInteractor(repository),
    [UseCases.addPlanzoneVirtualResource]:
      addPlanzoneVirtualResource.createInteractor(repository),
    [UseCases.addProjectVirtualResource]:
      addProjectVirtualResource.createInteractor(repository),
    [UseCases.removeResourceFromProject]:
      removeResourceFromProject.createInteractor(repository),
    [UseCases.addPlanzoneResourceToProject]:
      addPlanzoneResourceToProject.createInteractor(repository),
    [UseCases.addPlanzoneResourcesToProject]:
      addPlanzoneResourcesToProject.createInteractor(repository),
    [UseCases.addEveryoneToProject]:
      addEveryoneToProject.createInteractor(repository),
    [UseCases.removeResourceFromPlanzone]:
      removeResourceFromPlanzone.createInteractor(repository),
    [UseCases.editResource]: editResource.createInteractor(repository),
    [UseCases.editProjectResource]:
      editProjectResource.createInteractor(repository),
    [UseCases.editResourceWeeklyCalendar]:
      editResourceWeeklyCalendar.createInteractor(repository),
    [UseCases.retrieveResourceProjects]:
      retrieveResourceProjects.createInteractor(repository),
    [UseCases.assignManagerToResource]:
      assignManagerToResource.createInteractor(repository),
    [UseCases.unAssignManagerFromResource]:
      unAssignManagerFromResource.createInteractor(repository),
    [UseCases.assignEveryoneToManager]:
      assignEveryoneToManager.createInteractor(repository),
    [UseCases.removeSubordinates]:
      removeSubordinates.createInteractor(repository),
    [UseCases.retrieveResourceSubordinates]:
      retrieveResourceSubordinates.createInteractor(repository),
    [UseCases.retrievePlanzoneResourcesListing]:
      retrievePlanzoneResourcesListing.createInteractor(repository),
    [UseCases.retrieveProjectResourcesListing]:
      retrieveProjectResourcesListing.createInteractor(repository),
    [UseCases.retrieveFilterResources]:
      retrieveFilterResources.createInteractor(repository),
    [UseCases.retrieveResourcesByUuids]:
      retrieveResourcesByUuids.createInteractor(repository),
    [UseCases.retrievePlanzoneResourcesCounts]:
      retrievePlanzoneResourcesCounts.createInteractor(repository),
    [UseCases.assignCalendarHolidaysToResource]:
      assignCalendarHolidaysToResource.createInteractor(repository),
    [UseCases.retrieveResourceCalendarHolidays]:
      retrieveResourceCalendarHolidays.createInteractor(repository),
    [UseCases.disableProjectResource]:
      disableProjectResource.createInteractor(repository),
    [UseCases.activateProjectResource]:
      activateProjectResource.createInteractor(repository),
    [UseCases.disableResource]: disableResource.createInteractor(repository),
    [UseCases.activateResource]: activateResource.createInteractor(repository),
    [UseCases.unAssignCalendarHolidaysFromResource]:
      unAssignCalendarHolidaysFromResource.createInteractor(repository),
    [UseCases.addPlanzoneResourceToProjects]:
      addPlanzoneResourceToProjects.createInteractor(repository),
    [UseCases.changeProfilePicture]:
      changeProfilePicture.createInteractor(repository),
    [UseCases.retrieveProjectResourceAllocations]:
      retrieveProjectResourceAssignments.createInteractor(repository),
    [UseCases.transferProjectResourceAllocations]:
      transferProjectResourceAllocations.createInteractor(repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
